import { z } from "zod";

export const transferAccountAgreeFormSchema = z.object({
  agreeTransferCafe: z.boolean(),
});

export type TransferAccountAgreeFormType = z.infer<typeof transferAccountAgreeFormSchema>;
